// extracted by mini-css-extract-plugin
module.exports = {"nav":"tabs_nav__2on52","active":"tabs_active__2qXmN","nav1":"tabs_nav1__1_jTZ"};